import { NotificationDeliveryIndexView, NotificationDeliveryToken } from '../types/notification_deliveries';
import { MainV3ApiBase } from './base';

const Api = MainV3ApiBase.appendPath('users/current/notification_deliveries');

export const NotificationDeliveryApis = {
  async get(categories: string[], max_id?: number): Promise<NotificationDeliveryIndexView[]> {
    return await Api.get({ max_id, notification_categories: categories });
  },

  async show(token: NotificationDeliveryToken): Promise<NotificationDeliveryIndexView> {
    return await Api.appendPath(token).get();
  },

  async confirmNotificationDelivery(token: NotificationDeliveryToken) {
    return await Api.withId(token).appendPath('confirm_notification_delivery').post();
  },

  // 未読の通知の数を返す
  async getUnreadCount(): Promise<number> {
    return await Api.appendPath('unread_count').get();
  },
};
